var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgBtnFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.6726,
    cy: 13,
    r: 13,
    fill: "#1877F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7082 20.7997V13.4797H9.77264V10.8442H11.7082V8.5931C11.7082 6.82417 12.8515 5.19971 15.486 5.19971C16.5527 5.19971 17.3414 5.30197 17.3414 5.30197L17.2793 7.76311C17.2793 7.76311 16.4749 7.75528 15.5971 7.75528C14.6471 7.75528 14.4949 8.1931 14.4949 8.91976V10.8442H17.3548L17.2304 13.4797H14.4949V20.7997H11.7082Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.58218,
    height: 15.6,
    fill: "white",
    transform: "translate(9.77264 5.19971)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnFacebook);
export default __webpack_public_path__ + "static/media/btnFacebook.30ce3141f56d819d1889bae2d955b3ee.svg";
export { ForwardRef as ReactComponent };